module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-glx-plata-metalico.710f6fae.png";